import React from 'react';
import { useTranslation } from '../../contexts/LanguageContext';
import { PIECE_THEMES } from './index';

const PieceThemeSelector = ({ 
  pieceTheme, 
  setPieceTheme, 
  customPieceWhite,
  setCustomPieceWhite,
  customPieceBlack,
  setCustomPieceBlack,
  useCustomPieces,
  setUseCustomPieces 
}) => {
  const { t } = useTranslation();

  return (
    <section className="settings-section">
      <h3>♟️ {t('settings.pieceTheme')}</h3>
      
      <div className="theme-selector">
        <h4>{t('settings.presetThemes', 'Preset Themes')}:</h4>
        <div className="piece-theme-grid">
          {PIECE_THEMES.map(theme => (
            <button
              key={theme.id}
              className={`piece-theme-button ${pieceTheme === theme.id && !useCustomPieces ? 'active' : ''}`}
              onClick={() => {
                setPieceTheme(theme.id);
                setUseCustomPieces(false);
              }}
            >
              <div className="piece-preview">
                <div className="piece-circle" style={{ backgroundColor: theme.white }}></div>
                <span className="vs">VS</span>
                <div className="piece-circle" style={{ backgroundColor: theme.black }}></div>
              </div>
              <span>{theme.name}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="custom-colors">
        <h4>{t('settings.customColors')}:</h4>
        <div className="color-pickers">
          <div className="color-picker-item">
            <label>{t('settings.whitePieces')}:</label>
            <input
              type="color"
              value={customPieceWhite}
              onChange={(e) => {
                setCustomPieceWhite(e.target.value);
                setUseCustomPieces(true);
              }}
            />
            <span className="color-value">{customPieceWhite}</span>
          </div>
          <div className="color-picker-item">
            <label>{t('settings.blackPieces')}:</label>
            <input
              type="color"
              value={customPieceBlack}
              onChange={(e) => {
                setCustomPieceBlack(e.target.value);
                setUseCustomPieces(true);
              }}
            />
            <span className="color-value">{customPieceBlack}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PieceThemeSelector;
